module.exports = __webpack_public_path__ + "static/img/contact_logo4.29cd2f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo4.png
// module id = Gewk
// module chunks = 1